import delaysServices from '../services/delaysServices';
import dataModel from '../models/DataModel';
import OfflineQueue from './queue/OfflineQueue';
import DAO from './DAO.js';
import Metadata from '../helpers/metadata/Metadata';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';

export default class DelaysDAO extends DAO {

  constructor(store) {
    super(store, 'delay');

    this.OfflineQueue = OfflineQueue;

    this._delayID = -1;
    this.unsetDelay = this.unsetDelay.bind(this);
    this.clearDelays = this.clearDelays.bind(this);
    this.handleProjectDelay = this.handleProjectDelay.bind(this);
    this.setDelayInProject = this.setDelayInProject.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }

  get delayID() {
    return this._delayID--;
  }

  unsetDelay(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearDelays() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  async getDelay(delay_id, options) {
    return this._getItem(delay_id, delaysServices.getDelay.bind(this, delay_id, options), options);
  }

  async setDelayInProject(delay, action) {
    const project = await dataModel.projectsDAO.getProject(delay.project_id, { recordDescriptor: { project: { delays: {} } } });
    if (project) {
      if (!project.delays){
        project.delays = [];
      }
      if (action == 'delete') {
        project.delays = project.delays ? project.delays.filter(cc => {
          return cc.id != delay.id;
        }) : [];
      }
      else {
        let found = false;
        project.delays = project.delays ? project.delays.map(cc => {
          if (cc.id == delay.id) {
            found = true;
            return delay;
          }
          else {
            return cc;
          }
        }) : [];
        if (!found) {
          project.delays.push(delay);
        }
      }
      dataModel.projectsDAO.normalizeItem(project, { store: true });
      return project;
    }
    else {
      return null;
    }
  }
  
  async handleProjectDelay(response, action, delay, eventMetadatum, options) {

    if (response.offline) {
      this.markDirty(delay, true);
      console.log(delay);
      OfflineQueue.addQueueItem('delay', action, { id: delay.id, delay: delay, eventMetadatum: eventMetadatum });
      if (!options) {
        options = {};
      }
    
      options.store = true;
      StoreItemProcessing.normalizeItem(this.itemType, delay, options);
      return delay;
    }
    else {
      const delayInStore = StoreItemProcessing.normalizeAndSyncToStore(this.itemType, response, { store: true });

      let denormalizedDelay = this.mapToReturn(this.findItem(delayInStore.id));
      if (denormalizedDelay) {
        await this.setDelayInProject(denormalizedDelay, action);
    
        this.markDirty(denormalizedDelay, false);
        return denormalizedDelay;
      }
    }
  }  

  async handleResponse(response, action, delay, eventMetadatum, options) {
    if (response.error && !response.offline){
      dataModel.displayHTTPError(action, response.error, false);
    }
    else {
      if (delay.project_id) {
        return this.handleProjectDelay(response, action, delay, eventMetadatum, options);
      }
    }
  }

  async createDelay(delay, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return delaysServices.createDelay(delay, eventMetadatum, options).then(response => {
      if (response.error && !response.offline) {
        dataModel.displayHTTPError('Creating a delay', response.error, false);
      }
      else {
        if (response.offline) {
          delay.id = this.delayID;
          delay.user = dataModel.usersDAO.currentUser;
          return this.handleResponse(response, 'create', delay, eventMetadatum, options);
        }
        else {
          // if delay in store (may be true if delay added while offline)
          // then remove it
          const delayInStore = this.findItem(delay.id);
          if (delayInStore) {
            StoreItemProcessing.deleteItemInStore(this.itemType, delay.id);
          }
          delay.user = dataModel.usersDAO.currentUser;
          return this.handleResponse(response, 'create', delay, eventMetadatum, options);
        }
      }
    });
  }

  handleOfflineResponse(delay, activity, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    this.markDirty(delay, true);
    OfflineQueue.addQueueItem('delay', activity, { id: delay.id, delay: delay, eventMetadatum, options });
    return delay;
  }

  completeOfflineUpdate(queueItem) {
    const delay = this.findItem(queueItem.itemInfo.id);
    if (!delay) {
      return false;
    }
    switch (queueItem.operationKey) {
    case 'create':
      return this.createDelay(delay, queueItem.itemInfo.eventMetadatum);
    case 'delete':
      return this.deleteDelay(delay, queueItem.itemInfo.eventMetadatum);
    default:
      break;
    }
  }

  handleActionCableAndGetRequest(acData) {
    let delay = this.findItem(acData.delay_id);
    if (delay) {
      this.markNeedsSync(delay);
    }
    const options = {};
    switch (acData.type) {
    case 'updateDelay':
        // this update is just used to get attachments for now
      options.recordDescriptor = { delay: { attachments: {} } };
      return this.getDelay.bind(this);
    default:
    }
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_delays, options.toIgnore.delays, this.unsetDelay, this.clearDelays, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/DelaysDAO.js